/* eslint-disable */
import { createElement, createRef, Component } from 'react';
import styled, { ThemeProvider } from 'styled-components';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var autoFillAnimationStartName = 'onAutoFillStart';
var autoFillAnimationStopName = 'onAutoFillStop';
var getThemeValueOrDefault = function (theme) { return function (propName, defaultValue) {
    return theme && theme.xfor && theme.xfor.textField && theme.xfor.textField[propName]
        ? theme.xfor.textField[propName]
        : defaultValue;
}; };
var theme = function (theme) {
    var getThemeValueOrDefaultWithTheme = getThemeValueOrDefault(theme);
    return {
        height: getThemeValueOrDefaultWithTheme('height', 40),
        fontColor: getThemeValueOrDefaultWithTheme('fontColor', '#000000'),
        borderColor: getThemeValueOrDefaultWithTheme('borderColor', '#d8d8d8'),
        borderErroredColor: getThemeValueOrDefaultWithTheme('borderErroredColor', 'red'),
        bgColor: getThemeValueOrDefaultWithTheme('bgColor', '#FFFFFF'),
        bgDisabledColor: getThemeValueOrDefaultWithTheme('bgDisabledColor', '#ececec'),
        bgErroredColor: getThemeValueOrDefaultWithTheme('bgErroredColor', '#ffd9d9'),
        fontDisabledColor: getThemeValueOrDefaultWithTheme('fontDisabledColor', '#9a9a9a'),
        labelColor: getThemeValueOrDefaultWithTheme('labelColor', '#9c9c9c'),
    };
};
var Input = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var Label = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var Wrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  height: ", "px;\n  box-shadow: inset 0px ", " 0px 0px\n    ", ";\n  background-color: ", ";\n\n  ", " {\n    display: flex;\n    justify-content: flex-start;\n    align-items: ", ";\n    position: absolute;\n    line-height: 1;\n    pointer-events: none;\n    font-size: ", "rem;\n    top: 6px;\n    right: 6px;\n    bottom: 6px;\n    left: 6px;\n    color: ", ";\n  }\n\n  ", " {\n    display: block;\n    position: absolute;\n    width: 100%;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    color: ", ";\n    background: none;\n    border: 0;\n    padding: 1.7rem 6px 0;\n    margin: 0;\n    font-size: 1.4rem;\n    transition: all 0.3s ease-in-out;\n    outline: none;\n    ", ";\n\n    // Browser autofill hack to expose animation event for JS\n    &:-webkit-autofill {\n      animation-name: ", ";\n    }\n    &:not(:-webkit-autofill) {\n      animation-name: ", ";\n    }\n    @keyframes ", " {\n      from {\n        /**/\n      }\n      to {\n        /**/\n      }\n    }\n    @keyframes ", " {\n      from {\n        /**/\n      }\n      to {\n        /**/\n      }\n    }\n  }\n"], ["\n  position: relative;\n  height: ", "px;\n  box-shadow: inset 0px ", " 0px 0px\n    ", ";\n  background-color: ",
    ";\n\n  ", " {\n    display: flex;\n    justify-content: flex-start;\n    align-items: ",
    ";\n    position: absolute;\n    line-height: 1;\n    pointer-events: none;\n    font-size: ", "rem;\n    top: 6px;\n    right: 6px;\n    bottom: 6px;\n    left: 6px;\n    color: ", ";\n  }\n\n  ", " {\n    display: block;\n    position: absolute;\n    width: 100%;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    color: ", ";\n    background: none;\n    border: 0;\n    padding: 1.7rem 6px 0;\n    margin: 0;\n    font-size: 1.4rem;\n    transition: all 0.3s ease-in-out;\n    outline: none;\n    ", ";\n\n    // Browser autofill hack to expose animation event for JS\n    &:-webkit-autofill {\n      animation-name: ", ";\n    }\n    &:not(:-webkit-autofill) {\n      animation-name: ", ";\n    }\n    @keyframes ", " {\n      from {\n        /**/\n      }\n      to {\n        /**/\n      }\n    }\n    @keyframes ", " {\n      from {\n        /**/\n      }\n      to {\n        /**/\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.height;
}, function (_a) {
    var isFocused = _a.isFocused;
    return (isFocused ? '-2px' : '-1px');
}, function (_a) {
    var isErrored = _a.isErrored, theme = _a.theme;
    return (isErrored ? theme.borderErroredColor : theme.borderColor);
}, function (_a) {
    var isErrored = _a.isErrored, disabled = _a.disabled, theme = _a.theme;
    return disabled ? theme.bgDisabledColor : isErrored ? theme.bgErroredColor : theme.bgColor;
}, Label, function (_a) {
    var isFocused = _a.isFocused, isEmpty = _a.isEmpty, isAutoFilled = _a.isAutoFilled;
    return isFocused || !isEmpty || isAutoFilled ? 'flex-start' : 'center';
}, function (_a) {
    var isFocused = _a.isFocused, isEmpty = _a.isEmpty, isAutoFilled = _a.isAutoFilled;
    return (isFocused || !isEmpty || isAutoFilled ? '1' : '1.4');
}, function (_a) {
    var theme = _a.theme;
    return theme.labelColor;
}, Input, function (_a) {
    var theme = _a.theme;
    return theme.fontColor;
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return (disabled ? "color: " + theme.fontDisabledColor : '');
}, autoFillAnimationStartName, autoFillAnimationStopName, autoFillAnimationStartName, autoFillAnimationStopName);
var XforTextField = /** @class */ (function (_super) {
    __extends(XforTextField, _super);
    function XforTextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputRef = createRef();
        _this.state = {
            isAutoFilled: false,
        };
        return _this;
    }
    XforTextField.prototype.componentDidMount = function () {
        var _this = this;
        var inputEl = this.inputRef.current;
        inputEl &&
            inputEl.addEventListener &&
            inputEl.addEventListener('animationstart', function (e) {
                switch (e.animationName) {
                    case autoFillAnimationStartName:
                        _this.setState({ isAutoFilled: true });
                        break;
                    case autoFillAnimationStopName:
                        _this.setState({ isAutoFilled: false });
                        break;
                    default:
                        break;
                }
            });
    };
    XforTextField.prototype.render = function () {
        var _a = this.props, value = _a.value, isFocused = _a.isFocused, errorMessage = _a.errorMessage, isTouched = _a.isTouched, label = _a.label, name = _a.name, _b = _a.type, type = _b === void 0 ? 'text' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur;
        var isAutoFilled = this.state.isAutoFilled;
        var isErrored = isTouched && errorMessage.length > 0;
        return (createElement(ThemeProvider, { theme: theme },
            createElement(Wrapper, { isFocused: isFocused, isErrored: isErrored, isEmpty: !value.length, isAutoFilled: isAutoFilled, disabled: disabled },
                createElement(Input, { ref: this.inputRef, type: type, name: name, onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value }),
                createElement(Label, null, isErrored ? errorMessage : label))));
    };
    return XforTextField;
}(Component));
var templateObject_1, templateObject_2, templateObject_3;

export default XforTextField;
